import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';

@Component({
  selector: 'stx-simple-report-cell',
  templateUrl: './simple-report-cell.component.html',
  imports: [TranslateModule]
})
export class SimpleReportCellComponent {
  @Input() rowInputs: string[];
  @Input() rowInputsToTranslate: string[];
  @Input() inlineInputs: string[];
  @Input() inlineInputsToTranslate: string[];
}

@NgModule({
  imports: [CommonModule, TranslateModule, RouterModule, GeneralCommonsModule, SimpleReportCellComponent],
  exports: [SimpleReportCellComponent]
})
export class SimpleReportCellComponentModule {}
